var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Não há "),_c('b',[_vm._v("Estados")]),_vm._v(" cadastrados, tente novamente. ")])}]

export { render, staticRenderFns }